import React, { useEffect, useState } from 'react';
import { Check, Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { trackEvent } from '../lib/metaPixel';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 37
  });
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const checkoutUrls = {
    pro: 'https://profelisto.com.ar/checkouts/cn/hWNCfHYj8A1DfUGtlwsTHF9G/es-ar?_r=AQABKB9TSXWn3aKJswg11kcDtfHRBYOvmhkBCjqVAzi1We8',
    elite: 'https://profelisto.com.ar/checkouts/cn/hWNCfHYw5xpb1pEkAkmptNFC/es-ar?_r=AQAB6m98mBiPIJHvznXjVyEr07aNNt6BmSRwI3WSVDpBeX0'
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-20 bg-brand-mist" data-id="element-216">
      <div className="max-w-2xl mx-auto px-4" data-id="element-217">
        {/* Countdown header */}
        <div className="text-center mb-10" data-id="element-218">
          <h2 className="text-2xl md:text-3xl font-heading font-extrabold mb-6 text-brand-dark tracking-tight" data-id="element-219">
            ⏰ Precio de lanzamiento <br data-id="element-220" />
            <span className="text-brand-blue" data-id="element-221">Oferta por tiempo limitado</span>
          </h2>

          <div className="flex justify-center gap-3 mb-4" data-id="element-222">
            <div className="bg-white rounded-xl px-4 py-3 min-w-[72px] shadow-sm border border-brand-light" data-id="element-223">
              <div className="text-3xl font-bold font-mono text-brand-dark" data-id="element-224">
                {String(timeLeft.h).padStart(2, '0')}
              </div>
              <div className="text-[10px] tracking-widest text-gray-500 mt-1" data-id="element-225">
                HS
              </div>
            </div>
            <div className="text-3xl font-bold mt-3 text-brand-foam" data-id="element-226">:</div>
            <div className="bg-white rounded-xl px-4 py-3 min-w-[72px] shadow-sm border border-brand-light" data-id="element-227">
              <div className="text-3xl font-bold font-mono text-brand-dark" data-id="element-228">
                {String(timeLeft.m).padStart(2, '0')}
              </div>
              <div className="text-[10px] tracking-widest text-gray-500 mt-1" data-id="element-229">
                MIN
              </div>
            </div>
            <div className="text-3xl font-bold mt-3 text-brand-foam" data-id="element-230">:</div>
            <div className="bg-white rounded-xl px-4 py-3 min-w-[72px] shadow-sm border border-brand-light" data-id="element-231">
              <div className="text-3xl font-bold font-mono text-red-500" data-id="element-232">
                {String(timeLeft.s).padStart(2, '0')}
              </div>
              <div className="text-[10px] tracking-widest text-gray-500 mt-1" data-id="element-233">
                SEG
              </div>
            </div>
          </div>

          <p className="text-sm text-red-500 font-medium flex items-center justify-center gap-2" data-id="element-234">
            <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-235"></span>
            El precio sube cuando termina el contador
          </p>
        </div>

        {/* White card */}
        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl border border-brand-light" data-id="element-236">
          <div className="text-center mb-8" data-id="element-237">
            <h3 className="text-3xl md:text-4xl font-heading font-extrabold text-brand-dark mb-3 tracking-tight" data-id="element-238">
              Elegí tu Pack:
            </h3>
            <p className="text-gray-500 text-base md:text-lg" data-id="element-239">
              Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          {/* Pack Profesional row */}
          <button onClick={() => setSelected('pro')} className={`w-full text-left rounded-2xl p-5 mb-4 border-2 transition-all ${selected === 'pro' ? 'border-brand-blue bg-brand-mist' : 'border-gray-200 bg-white hover:border-brand-foam'}`} data-id="element-240">
            <div className="flex items-center gap-4" data-id="element-241">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'pro' ? 'border-brand-blue' : 'border-gray-300'}`} data-id="element-242">
                {selected === 'pro' && <div className="w-3 h-3 rounded-full bg-brand-blue" data-id="element-243"></div>}
              </div>

              <div className="text-2xl" data-id="element-244">📘</div>

              <div className="flex-grow" data-id="element-245">
                <div className="font-heading font-extrabold text-brand-dark text-lg leading-tight" data-id="element-246">
                  PACK PROFESIONAL
                </div>
                <div className="text-sm text-gray-500 mt-1" data-id="element-247">
                  12 Tomos + 6 Bonus
                </div>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-248">
                <div className="text-sm text-gray-400 line-through" data-id="element-249">
                  $29.990
                </div>
                <div className="text-xl md:text-2xl font-bold text-brand-dark" data-id="element-250">
                  $18.990
                </div>
              </div>
            </div>
          </button>

          {/* Megapack Elite row */}
          <button onClick={() => setSelected('elite')} className={`w-full text-left rounded-2xl p-5 border-2 transition-all ${selected === 'elite' ? 'border-brand-gold bg-brand-goldLight' : 'border-gray-200 bg-white hover:border-brand-foam'}`} data-id="element-251">
            <div className="flex items-start gap-4" data-id="element-252">
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center mt-1 transition-colors ${selected === 'elite' ? 'border-brand-gold' : 'border-gray-300'}`} data-id="element-253">
                {selected === 'elite' && <div className="w-3 h-3 rounded-full bg-brand-gold" data-id="element-254"></div>}
              </div>

              <div className="text-2xl mt-0.5" data-id="element-255">🏆</div>

              <div className="flex-grow" data-id="element-256">
                <div className="font-heading font-extrabold text-brand-dark text-lg leading-tight mb-2" data-id="element-257">
                  MEGAPACK ÉLITE
                </div>
                <div className="flex flex-wrap gap-2 mb-2" data-id="element-258">
                  <span className="inline-flex items-center gap-1 bg-brand-gold text-white font-bold text-xs px-3 py-1 rounded-full" data-id="element-259">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="inline-block bg-brand-goldLight text-brand-gold border border-brand-gold/40 font-bold text-xs px-3 py-1 rounded-full" data-id="element-260">
                    AHORRÁS $10.000
                  </span>
                </div>
                <div className="text-sm text-gray-600 leading-snug" data-id="element-261">
                  12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE
                </div>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-262">
                <div className="text-sm text-gray-400 line-through" data-id="element-263">
                  $49.990
                </div>
                <div className="text-xl md:text-2xl font-bold text-brand-gold" data-id="element-264">
                  $27.990
                </div>
              </div>
            </div>
          </button>

          {/* CTA */}
          <a href={checkoutUrls[selected]} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
          content_name: selected === 'elite' ? 'Megapack Élite' : 'Pack Profesional',
          value: selected === 'elite' ? 27990 : 18990,
          currency: 'ARS'
        })} className={`w-full mt-8 text-white font-bold text-lg py-5 rounded-2xl shadow-lg transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-3 ${selected === 'elite' ? 'bg-brand-gold hover:bg-[#B0923D] shadow-brand-gold/30' : 'bg-brand-blue hover:bg-brand-dark shadow-brand-blue/30'}`} data-id="element-265">
            <span data-id="element-266">
              SÍ, QUIERO EL{' '}
              {selected === 'elite' ? 'MEGAPACK ÉLITE' : 'PACK PROFESIONAL'}
            </span>
            <span className="text-xl" data-id="element-267">→</span>
          </a>

          <p className="text-center text-sm italic text-gray-400 mt-5" data-id="element-268">
            La opción más elegida por profesores de natación argentinos
          </p>
        </div>

        {/* Trust badges row */}
        <div className="grid grid-cols-2 gap-x-6 gap-y-4 mt-10 text-sm text-gray-600 max-w-md mx-auto" data-id="element-269">
          <div className="flex items-center gap-2" data-id="element-270">
            <Lock className="w-4 h-4 text-brand-blue" data-id="element-271" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-272">
            <Zap className="w-4 h-4 text-brand-aqua" data-id="element-273" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-2" data-id="element-274">
            <Shield className="w-4 h-4 text-green-600" data-id="element-275" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-276">
            <CreditCard className="w-4 h-4 text-brand-blue" data-id="element-277" /> Tarjeta ·
            Transferencia
          </div>
        </div>
      </div>
    </section>;
}